import React, { useState } from 'react';
import './ItemSlider.css';

const ItemSlider = ({ items }) => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleItems = 3; // Количество отображаемых элементов
  const itemWidth = Math.floor(110/3); // Ширина элемента + margin

  const handleNext = () => {
    if (startIndex + visibleItems < items.length) {
      setStartIndex(startIndex + visibleItems);
    }
  };
  setInterval(()=>{
    handleNext();
  },1000)

  return (
    <div className="slider-container">
      
      <div className="slider">
        <div
          className="slider-inner"
          style={{ transform: `translateX(-${startIndex * itemWidth}px)` }}
        >
          {items.map((item, index) => (
            <div className="slider-item" key={index}>
              {item}
            </div>
          ))}
        </div>
      </div>
      
    </div>
  );
};

export default ItemSlider;
